import { Injectable, OnInit, Renderer2, RendererFactory2 } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { Subject } from 'rxjs/internal/Subject';
import { GeneralService, JwtService, LocalStorageService } from '../index.service';
import { NavigationEnd, Router } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';
import { Meta } from '@angular/platform-browser';
import { BehaviorSubject, Observable, distinctUntilChanged, filter, first, map, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as moment from 'jalali-moment';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export default class GlobalService implements OnInit {
  ImageSubscription: Subject<string> = new Subject<string>();
  private previousUrl: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
  public previousUrl$: Observable<string | null> = this.previousUrl.asObservable();
  prevUrl?: string;
  currentUrl?: string;
  loadMoreTrigger = new Subject<string>();
  scrollTopValue = new Subject<number>();
  imgObject: any = {};
  animationTime: number = 1000;
  mobileToolbar: boolean = false;
  scrollVal: number = 0;
  removeMainMargin: boolean = false;
  footerPositionAbsoluteStatus = false
  touchScrollStatus = false;
  scaleStatus = false
  userAgent: any;
  returnUrl: string | null = null
  sideLinkChangeUrlNumber: number = 0;
  fullLoading = false
  CanSkippExited = true
  tableLodding = false
  preventRequest = false
  renderer: Renderer2;
  constructor(
    @Inject(PLATFORM_ID) private platform: Object,
    public jwtService: JwtService,
    private authGuardService: AuthGuard,
    private router: Router,
    private MetaService: Meta,
    private rendererFactory: RendererFactory2,
    private matDialog:MatDialog,
    private localStorageService: LocalStorageService,
    private general:GeneralService,
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.prevUrl = this.currentUrl;
      this.currentUrl = event.url;
      this.setPreviousUrl(this.prevUrl);
    });
  }
  ngOnInit(): void {
    this.setRemoveMainMargin(false)
  }

  setPreviousUrl(previousUrl: string | null | undefined) {
    this.previousUrl.next((previousUrl as any));
  }
  getPerviousUrlObs(path: any) {
    this.previousUrl$.pipe(
      first(),
      map(i => {
        // this.router.url.split('/').slice(0,this.router.url.split('/').length-1).join('/')
        return !i || i.includes(this.router.url) ? path : i
      }),
    ).subscribe(i => {
      path = i
    })
    this.router.navigate([path])
  }
  setFullLoading(bool: boolean) {
    this.fullLoading = bool
  }
  getFullLoading() {
    return this.fullLoading
  }
  lockScroll(bool: boolean) {
    let bodyElement = document.querySelector('body')
    if (bool) {
      this.renderer.addClass(bodyElement, 'overflow-y-hidden')
      this.renderer.addClass(bodyElement, 'body-custom')
    } else {
      this.renderer.removeClass(bodyElement, 'overflow-y-hidden')
      this.renderer.removeClass(bodyElement, 'body-custom')
    }
  }
  setRemoveMainMargin(value: boolean) {
    setTimeout(() => {
      this.removeMainMargin = value;
    }, 0);
  }
  scrollTop() {
    if (isPlatformBrowser(this.platform)) {
      window.scroll(0, 0);
    }
  }
  getYearFromDate(date: any) {
    return date.includes('T') ? date.split('T')[0].split('-')[0] : date.split(' ')[0].split('-')[0]
  }
  setDeviceDetector(userAgent: any) {
    this.userAgent = userAgent
  }
  getDeviceDetector() {
    return this.userAgent
  }
  changeScaleStatus(status: boolean) {
    this.scaleStatus = status
  }
  scrollToView(element: string, behaviorSmooth: boolean = true, position: ScrollLogicalPosition = "start") {
    if (isPlatformBrowser(this.platform)) {
      let scrollSpy = <HTMLElement>document.querySelector("#" + element)

      scrollSpy.scrollIntoView({
        behavior: behaviorSmooth ? "smooth" : "auto",
        block: position,
        inline: "nearest"
      })
    }
  }
  scrollToTopOfView(element: string, value: number = 0) {
    if (isPlatformBrowser(this.platform)) {
      this.scrollFunction(element, value)
    }
  }
  scrollFunction(element: string, value: number) {
    setTimeout(() => {
      window.scrollTo({
        top: this.findPosition(document.querySelector("#" + element)) - value,
        left: 0,
        behavior: 'smooth',
      });
    }, 10);
  }
  findPosition(obj: any): number {
    let currenttop: number = 0;
    if (obj?.offsetParent) {
      do {
        currenttop += obj.offsetTop;
      } while ((obj = obj.offsetParent));
    }
    return currenttop;
  }
  loadImage(imgName: any, time: number = 0) {
    setTimeout(() => {
      return this.imgObject[imgName] = true;
    }, time);
  }
  preventAccess() {
    if (!this.jwtService.checkAuth()) {
      this.jwtService.destination = this.router.url;
      this.authGuardService.preventAccess();
    }
  }
  setMobileToolbar(state: boolean) {
    this.mobileToolbar = state;
  }
  redirectTo(url: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate([url]));
  }

  setTouchScrollStatus(status: boolean) {
    this.touchScrollStatus = status
  }

  createMetaTag(tagName: any, content: any) {
    this.MetaService.updateTag(
      { name: tagName, content: content }
    )
  }

  removeMetaTag(tagName: any) {
    this.MetaService.removeTag(`name=${tagName}`)
  }
  convertMonthDegitToText(month: string) {
    if (month == '01') return 'فروردین'
    if (month == '02') return 'اردیبهشت'
    if (month == '03') return 'خرداد'
    if (month == '04') return 'تیر'
    if (month == '05') return 'مرداد'
    if (month == '06') return 'شهریور'
    if (month == '07') return 'ماه'
    if (month == '08') return 'آبان'
    if (month == '09') return 'آذر'
    if (month == '10') return 'دی'
    if (month == '11') return 'بهمن'
    else return 'اسفند'
  }

  convertDegitAndSignChar(value: string) {
    let text = '';
    text = value.replaceAll(/[A-Za-z0-9۱۲۳۴۵۶۷۸۹۰!@#$%^&*()_+=\-[\]\\{}|;':",./<>?]/g, '')
    return text
  }
  convertDegitAndSignCharEn(value: string) {
    let text = '';

    text = value.replaceAll(/[0-9!@#$%^&*()_+=\-[\]\\{}|;':",./<>?]/g, '')
    text = text.replaceAll(/[\u0600-\u06FF\uFB8A\u067E\u0686\u06AF]/g, '')
    return text
  }
  resetPerviousPath() {
    this.previousUrl.next(null)
  }
  checkUserIsOrganObs() {
    return this.jwtService.getCurrentAccountDataObs().pipe(
      filter((account: any) => account && account.username),
      map(account => {
        return account.username
      }),
      map((username: any) => {
        if (username.split('-')[0] == 'nrh') {
          return false
        } else {
          return true
        }
      }),
      distinctUntilChanged(),
    )
  }
  getDecimal(min: any) {
    return (min + "").split(".")[1];
  }
  convertTime(time: any) {
    let timeStr;
    if (time <= 60) {
      timeStr = '1 دقیقه'
    } else {
      if (time > 60 && time < 3600) {
        let min = Math.round(time / 60)
        timeStr = `${min} دقیقه`
      } else {
        let hour = Math.round(time / 3600)
        let decimal = +this.getDecimal((time / 3600).toString()).slice(0, 2)
        let min;
        if (decimal < 10) {
          min = decimal
        } else if (decimal < 55 && decimal > 45) {
          min = 30
        } else if (decimal > 10 && decimal <= 25) {
          min = 10
        } else if (decimal > 25 && decimal <= 45) {
          min = 20
        } else if (decimal >= 55 && decimal < 75) {
          min = 40
        } else {
          min = 50
        }
        timeStr = `${hour} ساعت ${min} دقیقه`
      }
    }
    return timeStr
  }
  isAfarine() {
    if (environment.production && environment.mode.prod) {
      return this.jwtService.storage.getData('identity') && this.jwtService.storage.getData('identity').username == 'nro-4c3s35f4ni' ? true : false
    } else {
      return true
    }
  }
  removeNonNumericCharacters(value: any): string {
    if (typeof value !== 'string') {
      return value
    }
    return value.replace(/\D/g, '');
  }
  returnGender(personObservable$: Observable<any>) {
    let gender = ''
    personObservable$.pipe(
      map(person => {
        gender = person.gender == 'MALE' ? 'MALE' : 'FEMALE'
      })).subscribe()
    return gender
  }
  checkDarkMode() {
    return this.localStorageService.getItem('theme') == 'dark'
  }
  getDateDisplay(dateInfo: any): string {
    let date = dateInfo
    if (typeof date == 'string') {
      date = date?.split('T')
      date[0] = date[0]?.split('-')?.reverse()
      date[0][1] = this.getMonth(+date[0][1])
      date[0][0] = date[0][0]?.split(' ')[0]
      date[0] = date[0]?.join(' ')
      return `${date[0]}`
    } else
      return 'تاریخ تولد را انتخاب کنید'
  }
  getMonth(mo: number): string {
    switch (mo) {
      case 1:
        return 'فروردین'
      case 2:
        return 'اردیبهشت'
      case 3:
        return 'خرداد'
      case 4:
        return 'تیر'
      case 5:
        return 'مرداد'
      case 6:
        return 'شهریور'
      case 7:
        return 'مهر'
      case 8:
        return 'آبان'
      case 9:
        return 'آذر'
      case 10:
        return 'دی'
      case 11:
        return 'بهمن'
      case 12:
        return 'اسفند'
      default:
        return ''
    }
  }
  handleImageDefualt(profile: 'organ'|'hamafarin'|'quiz'|'magazine'|string | undefined, gender = '', id = ''): Observable<string> {
    let image
    switch (profile) {
      case 'hamafarin':
        if (!this.checkDarkMode() && gender == 'FEMALE')
          image = 'assets/image/woman.svg'
        else if (this.checkDarkMode() && gender == 'FEMALE')
          image = 'assets/image/woman-dark.svg'
        else if (this.checkDarkMode() && gender == 'MALE')
          image = 'assets/image/person-dark.svg'
        else
          image = 'assets/image/person.svg'
        break
      case 'organ':
        image = this.checkDarkMode() ? 'assets/image/corporate_fare-dark.svg' : 'assets/image/corporate_fare.svg'

        break
      //   if (!this.checkDarkMode())
      // else
      //     image = 'assets/image/corporate_fare.svg'
      case 'quiz':
        image = 'assets/image/default.webp'
        break
      case 'magazine':
        image = 'assets/image/default.webp'
        break
      default:
        // image = 'assets/image/corporate_fare.svg'
        image = 'assets/image/default.webp'
    }

    return of(image)
  }
  priceConvert(value:any){
    let price = value.toString().split('').reverse().join('');
    price = price.toString().replace(/(.{3})/g, "$1,");
    if (price[price.length - 1] == ',') price = price.replace(/,$/, "");
    price = price.split("").reverse().join("");
    price = price?.replaceAll(/0/g, '۰')?.replaceAll(/1/g, '۱')?.replaceAll(/2/g, '۲')?.replaceAll(/3/g, '۳')?.replaceAll(/4/g, '۴')
    ?.replaceAll(/5/g, '۵')?.replaceAll(/6/g, '۶')?.replaceAll(/7/g, '۷')?.replaceAll(/8/g, '۸')?.replaceAll(/9/g, '۹')
    ?.replaceAll(/۰/g, '۰')?.replaceAll(/۱/g, '۱')?.replaceAll(/۲/g, '۲')?.replaceAll(/۳/g, '۳')?.replaceAll(/۴/g, '۴')
    .replaceAll(/۵/g, '۵')?.replaceAll(/۶/g, '۶')?.replaceAll(/۷/g, '۷')?.replaceAll(/۸/g, '۸')?.replaceAll(/۹/g, '۹');
    return price
  }
  distanceTimeUntilNow(data:any){
    let lastExamTime = Date.parse(moment(data, 'YYYY/M/D HH:mm:ss').format('YYYY/M/D HH:mm:ss'))
    let newDateTime = Date.parse(moment(new Date(), 'YYYY/M/D HH:mm:ss').format('YYYY/M/D HH:mm:ss'))
    let NDay:any = ''
    let n_diff = (newDateTime - lastExamTime) / (1000 * 60 * 60 * 24)
    if (n_diff <= 1) {
      NDay = 'امروز'
    } else if (n_diff > 1 && n_diff < 1.5) {
      NDay = 'دیروز'
    } else {
      let round = Math.ceil(n_diff)
      NDay = `${round} روز قبل`
    }
    return NDay
  }
  isNumber(s: string): boolean {
    const num = Number(s);
    return !isNaN(num) && isFinite(num);
  }
  isDialogOpen(): boolean {
    const openDialogs = this.matDialog.openDialogs;
    for (const dialogRef of openDialogs) {
      if (dialogRef.componentInstance && dialogRef.componentInstance?.id === 'app-are-you-sure') return true;
    }
    return false;
  }
  profileRoute(){
    let user = this.jwtService.getCurrentAccountData();
    if (user?.last_logined_role == 'USER') {
      return `/hamafarin/${user?.username}-${this.general.RegProfileUrl(user?.first_name)}-${this.general.RegProfileUrl(user?.last_name)}`
    }
    else {
      return `/organ/${user?.username}`
    }
  }
  isLAndScape() {
      if (window.screen.orientation) {
          return window.screen.orientation.type.includes('landscape');
      }
      // Fallback for browsers that don't support screen.orientation
      return window.innerWidth > window.innerHeight;
  }
  
  accountUrl() :string{   
    let user = this.jwtService.getCurrentAccountData()
    if (user?.last_logined_role == 'USER') {
      return `/hamafarin/${user?.username}-${this.general.RegProfileUrl(user?.first_name)}-${this.general.RegProfileUrl(user?.last_name)}`
    }
    else {
      return `/organ/${user?.username}`
    }
  }
}